import StorageManager from "./StorageManager";

const currentUserKey = "cms-current-user";

function setCurrentUser(currentUser) {
    StorageManager.setItem(currentUserKey, JSON.stringify(currentUser));
    return getCurrentUser();
}

function removeCurrentUser() {
    StorageManager.removeItem(currentUserKey);
}

function getCurrentUser() {
    let item = StorageManager.getItem(currentUserKey);
    if (item)
        return JSON.parse(item);
    else
        return null;
}

function isAuthenticated() {
    return getCurrentUser() != undefined && getCurrentUser() != null;
}

function hasAnyRoles(authorities) {
    //TODO: check authorities
    return getCurrentUser() != undefined && getCurrentUser() != null;
}


let Auth = {
    setCurrentUser: setCurrentUser,
    getCurrentUser: getCurrentUser,
    isAuthenticated: isAuthenticated,
    hasAnyRoles: hasAnyRoles,
    logout() {
        removeCurrentUser();
    }
};

export default Auth;


